module.exports = __webpack_public_path__ + "static/media/logo.3b8bd622.png";